// This file was generated by "make codegen/iam". DO NOT EDIT.

import { APPLY_EXCEPTION_MUTATION as ACTION_MONDOO_POLICY_EXTENDEDHUB_APPLYEXCEPTIONMUTATION } from "~/lib/iam/actions/mondoo/policy/ExtendedHub/ApplyExceptionMutation/action";
import { EXTEND_EXCEPTION as ACTION_MONDOO_POLICY_EXTENDEDHUB_EXTENDEXCEPTION } from "~/lib/iam/actions/mondoo/policy/ExtendedHub/ExtendException/action";
import { GET_EXCEPTIONS as ACTION_MONDOO_POLICY_EXTENDEDHUB_GETEXCEPTIONS } from "~/lib/iam/actions/mondoo/policy/ExtendedHub/GetExceptions/action";
import { GET_EXCEPTION_FILTER_SUGGESTIONS as ACTION_MONDOO_POLICY_ASSETSTORE_GETEXCEPTIONFILTERSUGGESTIONS } from "~/lib/iam/actions/mondoo/policy/AssetStore/GetExceptionFilterSuggestions/action";

export const allowedActions = [
  ACTION_MONDOO_POLICY_ASSETSTORE_GETEXCEPTIONFILTERSUGGESTIONS,
  ACTION_MONDOO_POLICY_EXTENDEDHUB_APPLYEXCEPTIONMUTATION,
  ACTION_MONDOO_POLICY_EXTENDEDHUB_EXTENDEXCEPTION,
  ACTION_MONDOO_POLICY_EXTENDEDHUB_GETEXCEPTIONS,
] as const;
